import TempSubscriberPassHandler from './temp_subscriber_pass_handler';
import shouldDisplayGate from './gate_display';
import { isTechTargetDiveSite, setUpSmartformsGate } from './techtarget_gate';
import { isRecognizedUser } from '../user';
/* global grecaptcha, divecounter */

$(document).ready(() => {
  const signupGate = {
    designStandard: 'standard',
    designFullWidth: 'full-width',
    designFullWidthTracker: 'full-width-tracker',
    // Immediate gate configured per-newspost via NewsPostGate.enabled.
    gateEnabled: window.gateEnabled === 'True',
    // CMS (staff) users are never metered; they only see gates set to always enabled.
    cmsUserSignedIn: window.cmsUserSignedIn === true,
    cssClass: window.cssClass,
    newsletter: window.siteName,
    tempSubscriberMark: '',
    siteName: window.siteName.toLowerCase().replace(/ /g, '_'),
    designType: window.designType,
    $contentGate: $('#content_gate_signup'),
    $overlay: $('#newspost_overlay'),
    articleBody: '.article-body',
    adClass: '.hybrid-ad-wrapper',
    $accessButton: $('#content_gate_button button'),
    confirmationLabel: '#confirmation',
    contentStart: 'article', // maybe not needed
    signupApiUrl: '/apisignup/',
    emailInputId: '#content_gate_input',
    $inputContainer: $('#input-container'),
    $signupList: $('#content_gate_signup .signup-list'),
    $signupInline: $('div[id*="inline-signup"]'),
    $signupFooter: $('.elevated-footer'),
    $signupFormErrorMessage: $('#content_gate_signup .signup-form-error-message'),
    $userConsentInput: $('#id_user_consent-gate'),
    $captchaContainer: $('#content_gate_signup .captcha-container'),
    $v2Element: $('#content_gate_signup .g-recaptcha'),
    $creditSection: $('.credits-section'),
    $socialTagsSection: $('.full-width__post-article-wrapper'),
    extraMargin: '4rem',
    originalMargin: '2rem',
    originalArticleHeight: $('.article-body').height(),
    firstAdSpotPosition: '450px',
    $previewCutoff: $('#content-gate-spot'),
    // Use reCAPTCHA v3 score first; show v2 challenge if score is too low.
    recaptchaSiteKey: window.contentGateRecaptchaSiteKey,
    recaptchaV3SiteKey: window.contentGateRecaptchaV3SiteKey,
    recaptchaScoreThreshold: 0.5,
    recaptchaSubmitAction: 'signup_submit',
    recaptchaPageAction: 'signup_page_load',
    recaptchaWatcherInterval: null,
    gateSubmissionCompleted: false,

    getGateProportionalPosition() {
      // The gate position is adjusted to maintain
      // a consistent preview area (in pixel squares)
      // for articles of varying lengths.
      const width = $('.article-body').width();
      const previewArea = 310 * 1000; // pixel squares
      const gatePosition = previewArea / width;
      return gatePosition;
    },

    showGateAndOverlay() {
      this.$overlay.show();
      this.$contentGate.show();
    },

    hasMetMeteringThreshold() {
      return typeof divecounter !== 'undefined'
        && typeof divecounter.canShowMeteringGate === 'function'
        && divecounter.canShowMeteringGate();
    },

    // Show the gate if it's configured to show immediately on this newspost (even for
    // CMS users), or if a non-CMS user has hit the metering page-view threshold.
    shouldDisplayGate() {
      return shouldDisplayGate({
        gateEnabled: this.gateEnabled,
        cmsUserSignedIn: this.cmsUserSignedIn,
        meteringThresholdMet: this.hasMetMeteringThreshold(),
      });
    },

    isTabletOrSmaller() {
      // 1024px (64em) is our medium breakpoint for tablet
      return $(window).width() <= 1024;
    },

    isMobile() {
      // 640px (40em) is our small breakpoint for mobile phones
      return $(window).width() <= 640;
    },

    setupMobileDesign() {
      if (this.isMobile()) {
        this.$signupList.insertAfter(this.emailInputId);
        this.$accessButton.css('font-size', '0.95rem');
        this.$overlay.css('height', '16rem');
      }
    },

    getFirstAdIndex() {
      // The first visible ad is the 'second' ad for the standard desktop design
      return !this.isTabletOrSmaller() && this.designStandard === this.designType ? 1 : 0;
    },

    hideFirstAd() {
      const adIndex = this.getFirstAdIndex();
      $(this.articleBody).children(this.adClass).eq(adIndex).hide();
    },

    getVisibleTrackerItems() {
      return $('#tracker-container')
        .find('.tracker__item')
        .filter(function() {
          return $(this).is(':visible');
        });
    },

    getFirstVisibleTrackerItem() {
      return this.getVisibleTrackerItems().first();
    },

    openFirstTrackerItem() {
      $('.keep-reading-btn').first().click();
    },

    hideAdditionalTrackerItems() {
      this.getVisibleTrackerItems().slice(1).hide();
    },

    disableTrackerFilters() {
      $('.filter-label').hide();
      $('[id^="show-desktop-dropdown-"]').prop('disabled', true);
      $('.desktop-dropdown').addClass('tracker_filter_disabled');
      $('.mobile-filter > select').prop('disabled', true);
      $('.mobile-filter').addClass('tracker_filter_disabled');
      $('.clear-filters').addClass('tracker_clear_link_disabled');
      $('#save-mobile-filter').addClass('button--disabled save-disabled');
      $('#save-mobile-filter').prop('disabled', true);
    },

    enableTrackerFilters() {
      $('.filter-label').show();
      $('[id^="show-desktop-dropdown-"]').prop('disabled', false);
      $('.desktop-dropdown').removeClass('tracker_filter_disabled');
      $('.mobile-filter > select').prop('disabled', false);
      $('.mobile-filter').removeClass('tracker_filter_disabled');
      $('.clear-filters').removeClass('tracker_clear_link_disabled');
      $('#save-mobile-filter').removeClass('button--disabled save-disabled');
      $('#save-mobile-filter').prop('disabled', false);
    },

    hideTrackerAds() {
      $(this.adClass).hide();
    },

    setupTrackerGate() {
      this.getFirstVisibleTrackerItem()
        .find(this.cssClass)
        .first()
        .append(this.$overlay);
      this.addStructuredDataClass();
      this.showGateAndOverlay();
    },

    setTrackerBodyMaxHeight() {
      // Wait for keep-reading-btn to expand the tracker__body before setting max-height
      const height = $('.tracker__body').first().outerHeight();
      setTimeout(() => {
        // Set gate to half the height of the tracker__body
        $('.tracker__body').first().css('max-height', height / 2);
      }, 500);
    },

    moveGateToFirstTrackerItem() {
      this.$contentGate.insertAfter(this.getFirstVisibleTrackerItem());
    },

    fadeOutGate() {
      const $articleBody = $(this.articleBody);
      $articleBody.find('#newspost_overlay').fadeOut();
      $articleBody.animate(
        {
          'max-height': `${this.originalArticleHeight}`,
        },
        {
          duration: 1000,
          // Hide overflow while in transition.
          // Can't set this permenantly because it messes breakpoints
          // that editorial occastionaly uses. See ENGB-1324
          start: () => $articleBody.css({ overflow: 'hidden' }),
          done: () => $articleBody.css({ overflow: 'visible', 'max-height': '100%' }),
        },
      );
    },

    increasePaddingForSocialTags() {
      this.$socialTagsSection.css('margin-top', this.extraMargin);
    },

    decreasePaddingForSocialTags() {
      this.$socialTagsSection.css('margin-top', this.originalMargin);
    },

    hideCreditSection() {
      this.$creditSection.hide();
    },

    showCreditSection() {
      this.$creditSection.show();
    },

    hideFooterSignup() {
      this.$signupFooter.hide();
    },

    hideInlineSignups() {
      this.$signupInline.hide();
    },

    hideSignups() {
      this.hideInlineSignups();
      this.hideFooterSignup();
    },

    showConsentError() {
      this.$signupFormErrorMessage.show();
    },

    hideConsentError() {
      this.$signupFormErrorMessage.hide();
    },

    checkUserConsent() {
      return this.$userConsentInput.prop('checked');
    },

    // Most of this code is copied from the dive_mailcheck.js
    // Since this is a prototype, copying-pasting then modifying
    // for now.
    checkEmailAndRespond(textfield) {
      $(textfield).mailcheck({
        suggested(element, suggestion) {
          // remove old instances of the warning - anywhere on the page
          $('.js-already-subscriber-prompt').remove();
          $('.js-email-check').remove();

          const textToAdd = window.interpolate(
            window.gettext('Did you mean %(suggestedDomain)s?'),
            { suggestedDomain: `<b>${suggestion.domain}</b>` },
            true,
          );
          const htmlToAdd = `<p class="email-check js-email-check padding-left">${textToAdd}</p>`;
          signupGate.$inputContainer.after(htmlToAdd);
        },
        empty() {
          $('.js-already-subscriber-prompt').remove();
          $('.js-email-check').remove();
          const textToAdd = window.gettext('Already a subscriber? Sign in with your email above.');
          const htmlToAdd = `<p class="email-check js-email-check padding-left">${textToAdd}</p>`;
          signupGate.$inputContainer.after(htmlToAdd);
        },
      });
    },

    pushContentGateEvents() {
      const contentGateSignupEventObjects = [
        // Standard Signup Event that is submitted on every newsletter signup
        {
          event: 'user.newsletterSignup',
          'user.newsletterSignup': {
            v: 12, // <-- DO NOT EDIT.
            name: 'EmailSignup-content-gate',
            location: 'content-gate', // emailSignupLocation to populate string
            signup_referrer: window.location.pathname, // page path the user signed up on
          },
        },
        // Content Gate specific signup event.
        // Audience want's both to make it easier to distringuish content gate signups
        {
          event: 'user.newsletter_signup_content_gate',
          'user.newsletter_signup_content_gate': {
            name: 'Newsletter Signup Content Gate',
            location: 'content-gate', // emailSignupLocation to populate string
            signup_referrer: window.location.pathname,
          },
        },
      ];

      contentGateSignupEventObjects.forEach((eventObject) => window.pushGTMEvent(eventObject));
    },

    // Keep all success actions in one place and avoid running them twice.
    completeGateSignup() {
      if (this.gateSubmissionCompleted) {
        return;
      }
      this.gateSubmissionCompleted = true;
      if (this.recaptchaWatcherInterval) {
        clearInterval(this.recaptchaWatcherInterval);
      }
      const handler = new TempSubscriberPassHandler();
      handler.setEditorialGateBypassToken();
      this.signup();
      this.removeContentGate();
      this.pushContentGateEvents();
    },

    // Read the reCAPTCHA v2 token from grecaptcha or the hidden textarea.
    getV2Response() {
      let response = '';
      if (typeof grecaptcha !== 'undefined') {
        try {
          response = grecaptcha.getResponse();
        } catch (e) {
          response = '';
        }
      }
      if (!response) {
        const textareaInForm = this.$contentGate.find('textarea[name="g-recaptcha-response"]').first();
        if (textareaInForm.length && textareaInForm.val()) {
          response = textareaInForm.val();
        }
      }
      return response;
    },

    // Show the v2 challenge and watch for completion.
    showV2Challenge() {
      this.$captchaContainer.show();
      if (this.recaptchaWatcherInterval) {
        clearInterval(this.recaptchaWatcherInterval);
      }
      this.recaptchaWatcherInterval = setInterval(() => {
        if (this.gateSubmissionCompleted) {
          clearInterval(this.recaptchaWatcherInterval);
          return;
        }
        if (this.getV2Response()) {
          clearInterval(this.recaptchaWatcherInterval);
          this.completeGateSignup();
        }
      }, 250);
    },

    // Execute v3 and send the token to the score endpoint.
    runV3AndScore() {
      return grecaptcha.execute(this.recaptchaV3SiteKey, { action: this.recaptchaSubmitAction })
        .then((token) => fetch('/signup/recaptcha-v3-score/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token, action: this.recaptchaSubmitAction }),
        }))
        .then((response) => response.json());
    },

    // If v3 score passes, complete signup; otherwise show the v2 challenge.
    handleRecaptchaSubmit() {
      if (!this.recaptchaV3SiteKey || typeof grecaptcha === 'undefined') {
        this.showV2Challenge();
        return;
      }

      grecaptcha.ready(() => {
        this.runV3AndScore()
          .then((data) => {
            const score = Number(data && data.score);
            const recaptchaSuccess = Boolean(data && (data.recaptcha_success || data.success));
            const scorePass = this.recaptchaPassWhenLowScore
              ? (!Number.isNaN(score) && score < this.recaptchaScoreThreshold)
              : (!Number.isNaN(score) && score > this.recaptchaScoreThreshold);

            if (recaptchaSuccess && scorePass) {
              this.completeGateSignup();
              return;
            }
            this.showV2Challenge();
          })
          .catch(() => {
            this.showV2Challenge();
          });
      });
    },

    // Trigger the page-load v3 action.
    runPageLoadRecaptchaCheck() {
      if (!this.recaptchaV3SiteKey || typeof grecaptcha === 'undefined') {
        return;
      }
      grecaptcha.ready(() => {
        grecaptcha.execute(this.recaptchaV3SiteKey, {
          action: this.recaptchaPageAction,
        }).catch(() => {});
      });
    },

    setupEmailValidation() {
      $(this.emailInputId).on('blur', () => {
        signupGate.checkEmailAndRespond(signupGate.emailInputId);
      });
      signupGate.checkEmailAndRespond(signupGate.emailInputId);
    },

    getUTMParams() {
      // gets utm params from current url
      const urlParams = new URLSearchParams(window.location.search);
      const utmParams = {};
      const fields = ['utm_campaign', 'utm_medium', 'utm_source'];
      fields.forEach((field) => {
        if (urlParams.has(field)) {
          utmParams[field] = urlParams.get(field);
        }
      });
      return utmParams;
    },

    signup() {
      const email = $('#content_gate_input').val();
      if (typeof jstag !== 'undefined') {
        const payload = {
          email,
          _e: 'Email lookup',
        };
        // eslint-disable-next-line no-undef
        jstag.send(payload);
      }
      const externalReferrer = sessionStorage.getItem('externalReferrer');
      const referralUrl = externalReferrer !== 'direct' ? externalReferrer : window.location.href;
      const requestData = {
        email,
        list_name: this.newsletter,
        subscribe_requested: '1',
        source: 'content-gate',
        referral_url: referralUrl,
        signup_internal_referrer: window.location.href,
        ...this.getUTMParams(),
        ...(externalReferrer && externalReferrer !== 'direct' && { signup_external_referrer: externalReferrer }),
      };
      $.ajax({
        type: 'POST',
        url: this.signupApiUrl,
        data: requestData,
        success() {
          const handler = new TempSubscriberPassHandler();
          handler.setEditorialGateBypassToken();
        },
      });
    },

    updateMaxHeightForOverlay() {
      $(this.articleBody).css('max-height', this.getGateProportionalPosition());
    },

    showSuccessConfirmation() {
      const successConfirmation = `
      <div id="editorial_gate_confirmation" class="message message--success">
        ${window.gettext('Email submitted.')}
        <a class="analytics t-article-editorial-gate-success-message" href="https://divenewsletters.com/" target="_blank">
            ${window.gettext('Browse more newsletters')}
        </a>
        <img class="message__close" src="/static/img/components/messages/close.svg" alt="${window.pgettext('verb', 'close')}">
      </div>`;

      // Appends the success message and fades it in
      $('.page-wrapper').append(successConfirmation);

      // Add event handler to close the confirmation
      // Normally, the click event handler is added in app.js
      // However, since we are adding the confirmation element late,
      // we need to add the event handler again here
      $('.message__close').click(function() {
        $($(this).closest('.message')).fadeOut('fast');
      });

      $('.message').fadeIn(1000);
    },

    hideSuccessConfirmation() {
      // Hide the success confirmation after 7 seconds
      setTimeout(() => {
        $('.message').fadeOut(1000, () => {
          // Hide the div after it fades out
          $('.message').hide();
        });
      }, 7000);
    },

    moveGateBeforeCredits() {
      this.$contentGate.insertAfter($(this.articleBody));
    },

    addOverlayCss() {
      $(this.cssClass).addClass('overlay');
    },

    removeOverlayCss() {
      $(this.cssClass).removeClass('overlay');
    },

    addStructuredDataClass() {
    // Gated class is used to identify to google crawlers that this content is gated
    // in order to prevent a negative SEO hit. See ENGB-432, as well as the
    // structured data added in content_gate.html
      if (this.designType === this.designFullWidthTracker) {
        $('#tracker-container').addClass('gated');
      } else {
        $(this.cssClass).addClass('gated');
      }
    },

    removeContentGate() {
      if (this.designType === this.designFullWidthTracker) {
        this.$contentGate.hide();
        // show the confirmation message
        $('.message').fadeIn(1000);
        // make the first tracker item fully visible
        const firstTrackerItem = $('.tracker__body').first();
        // function to reveal all other tracker items
        const showRest = () => {
          $('.tracker__item').slice(1).show();
          firstTrackerItem.css('max-height', '100%');
        };
        firstTrackerItem.animate({
          'max-height': `${firstTrackerItem.height() * 2}`,
        }, 500, showRest);

        this.enableTrackerFilters();
        this.getFirstVisibleTrackerItem()
          .find('#newspost_overlay')
          .fadeOut();
      } else {
        this.fadeOutGate();
        this.$contentGate.remove();
        this.showCreditSection();
        this.removeOverlayCss();
      }
      this.showSuccessConfirmation();
      this.hideSuccessConfirmation();
    },

    setUpContentGate() {
      // This is for debugging purposes needs to be removed before merging to main
      window.signupGate = this;
      // Keep this form on-page; submit behavior is handled in JS.
      this.$contentGate.attr('action', '#');
      // This is for styling purposes, not functional
      this.increasePaddingForSocialTags();
      this.hideCreditSection();
      // We want to hide certain signup placement as a part of business logic
      this.hideSignups();
      this.setupMobileDesign();
      this.runPageLoadRecaptchaCheck();

      if (this.designType === this.designFullWidthTracker) {
        this.openFirstTrackerItem();
        this.moveGateToFirstTrackerItem();
        this.hideAdditionalTrackerItems();
        this.disableTrackerFilters();
        this.hideTrackerAds();
        this.setupTrackerGate();
        this.setTrackerBodyMaxHeight();
      } else {
        this.updateMaxHeightForOverlay();
        this.moveGateBeforeCredits();
        this.hideFirstAd();
        this.addOverlayCss();
        this.addStructuredDataClass();
        this.$overlay.appendTo(this.cssClass);
        // Finally show the gate and overlay
        this.showGateAndOverlay();
      }

      // Use a namespaced submit handler so setup does not add duplicates.
      this.$contentGate.off('submit.contentGateRecaptcha').on('submit.contentGateRecaptcha', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        signupGate.hideConsentError();
        if (!signupGate.checkUserConsent()) {
          signupGate.showConsentError();
          return false;
        }
        signupGate.handleRecaptchaSubmit();
        return false;
      });

      this.$userConsentInput.click(() => {
        signupGate.hideConsentError();
      });

      $(this.emailInputId).on('blur', () => {
        signupGate.checkEmailAndRespond(signupGate.emailInputId);
      });

      $(this.emailInputId).on('click, focus', () => {
        const $checkBoxList = signupGate.$signupList;
        const numberOfCheckboxes = $checkBoxList.children().length; // get number of checkboxes
        if (numberOfCheckboxes > 0) { // drop down list when clicking input
          $checkBoxList.slideDown('500');
        }
      });
    },

    renderGate() {
      // Tracker posts keep the regular gate: the smartforms gate reuses the
      // single-article layout helpers, which don't fit the tracker layout.
      const isTracker = this.designType === this.designFullWidthTracker;
      if (isTechTargetDiveSite() && !isTracker) {
        setUpSmartformsGate(this);
      } else {
        this.setUpContentGate();
      }
    },
  };

  const previewGatePage = window.previewGatePage === 'True';
  const showGatePreview = window.showGatePreview === 'True';

  // Used on every site except TechTarget, which uses isRecognizedUser() below.
  const lyticsCallback = function(profile) {
    // All sub lists follow the any_DIVE-NAME_subs format.
    // For example, Retail Dive is any_retail_dive_subs.
    // All trial lists follow the all_DIVE-NAME_trial_subscribers format.
    const usersAudienceArray = profile.data.user.segments;
    // we expect lytics segments to be in the format of `any_DIVE-NAME_subs`
    // so that we can check if the user is a subscriber or not.
    // where DIVE-NAME is lowercase, spaces replaced with underscores,
    // and dashes removed.
    // Examples
    // Retail Dive -> any_retail_dive_subs,
    // C-Store Dive-> any_cstore_dive_subs
    const diveName = window.siteName.toLowerCase()
      .replace(/ /g, '_')
      .replace(/-/g, '');
    const subList = `any_${diveName}_subs`;
    const trialList = `all_${diveName}_trial_subscribers`;
    const isSub = usersAudienceArray.indexOf(subList) > -1;
    const isTrial = usersAudienceArray.indexOf(trialList) > -1;

    const handler = new TempSubscriberPassHandler();
    if (isSub || isTrial || handler.hasValidToken()) {
      // Leave early given the user is a subscriber
      $('.preview-gate-message .with-gate').show();
      return;
    }
    $('.preview-gate-message .without-gate').show();
    if (signupGate.shouldDisplayGate()) {
      signupGate.setUpContentGate();
    }
  };

  // TechTarget only; called after shouldDisplayGate() has already passed.
  // The preview banner is server-rendered with an always-visible link (see
  // preview_gate_message.html), so only the gate itself needs rendering here.
  const applyDiveGateDecision = (recognized) => {
    if (!recognized) {
      signupGate.renderGate();
    }
  };

  // previewGatePage allows the user to preview the gate without enabling via a query param
  // when they are logged to the CMS, we force the gate into a certain state in that instance.
  if (previewGatePage && showGatePreview) {
    signupGate.renderGate();
  } else if (!previewGatePage) {
    if (isTechTargetDiveSite()) {
      // Checked first because recognition can wait several seconds on Lytics.
      if (signupGate.shouldDisplayGate()) {
        isRecognizedUser().then(
          applyDiveGateDecision,
          // A rejection handler rather than .catch(), so an error while rendering
          // doesn't render the gate a second time.
          () => applyDiveGateDecision(false),
        );
      }
    } else if (typeof jstag !== 'undefined') {
      // lytics could not be loaded due to something like the adblocker/cookie banner,
      // so check to see if it's defined.
      // eslint-disable-next-line no-undef
      jstag.call('entityReady', lyticsCallback);
    } else {
      // Without jstag we can't check Lytics segments, but the local bypass token
      // (set right after a successful gate signup) doesn't depend on it - honor
      // that before defaulting to showing the gate for anyone else.
      const handler = new TempSubscriberPassHandler();
      if (!handler.hasValidToken() && signupGate.shouldDisplayGate()) {
        signupGate.setUpContentGate();
      }
    }
    // the preview-gate-message element is not there when the user is not logged in
    $('.preview-gate-message').css({ display: 'flex' });
  }
});
